import { render, staticRenderFns } from "./DatasetSource.vue?vue&type=template&id=506cf5e0"
import script from "./DatasetSource.vue?vue&type=script&lang=js"
export * from "./DatasetSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports